import NotFoundView from '@/components/error/404.vue'
import Agentmanagement from '@/components/view/Agentmanagement/main.vue'
import Account from '@/components/view/allbots/Account'
import SettingComponent from '@/components/view/billing/SettingComponent'
import Upgrade from '@/components/view/billing/Upgrade'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Chat from '@/components/view/chat/Chat'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'
import Dashboard from '@/components/view/dashboard/Dashboard'
import Export from '@/components/view/Export/Export'
import GetCurrentLocation from '@/components/view/GetCurrentLocation.vue'
import Setup from '@/components/view/getstarted/Setup'
import Comment from '@/components/view/intent/CommentToInbox'
import Conversation from '@/components/view/intent/Conversation'
import Training from '@/components/view/intent/Training/index'
import Live from '@/components/view/live/Main'
import LivechatView from '@/components/view/livechat/LivechatView'
import PBlog from '@/components/view/partner/Blog'
// import PCustomer from '@/components/view/partner/Customer'
import PProfile from '@/components/view/partner/Profile'
import PRedeemCode from '@/components/view/partner/RedeemCode'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import BbqUnansweredMsgInfo from '@/components/view/template/Bbq/UnansweredMsgInfo.vue'
import CityFreshAgentmanagement from '@/components/view/template/cityfresh/agentmanagement/CityFreshAgentmanagement.vue'
import CityFreshManagement from '@/components/view/template/cityfresh/management/CityFreshManagement.vue'
import CityFreshProfile from '@/components/view/template/cityfresh/profile/CityFreshprofile.vue'
import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'
import FoodguruCustomer from '@/components/view/template/foodguru/main.vue'
import HopinnHrHumanResource from '@/components/view/template/HopinnHr/HumanResource.vue'
import KingkitchenAdminmenu from '@/components/view/template/kingKitchen/adminMenu/main.vue'
import KingkitchenMember from '@/components/view/template/kingKitchen/member/main.vue'
import LamyManagement from '@/components/view/template/lamy/main.vue'
import LamyMembership from '@/components/view/template/lamy/Membership.vue'
import LamyProductAndBranch from '@/components/view/template/lamy/ProductAndBranch/main.vue'
import LamyPurchaseBehavior from '@/components/view/template/lamy/PurchaseBehavior/main.vue'
import NongtungjaiSelfReferral from '@/components/view/template/NongTungJai/SelfReferral/index.vue'
import NongtungjaiPatientHistory from '@/components/view/template/NongTungJai/PatientHistory.vue'
import NongtungjaiPatientHistoryDetails from '@/components/view/template/NongTungJai/PatientHistoryDetails.vue'
import PowerbuyAnalytics from '@/components/view/template/powerbuy/Analytics/main.vue'
import PowerbuyBranchManagement from '@/components/view/template/powerbuy/BranchManagement/BranchManagement.vue'
import PowerbuySubBranchManagement from '@/components/view/template/powerbuy/BranchManagement/SubBranchManagement.vue'
import TremendousCustomerInfo from '@/components/view/template/Tremendous/CustomerInfo.vue'
import TremendousCustomerList from '@/components/view/template/Tremendous/CustomerList.vue'
import AiraAifuMember from '@/components/view/template/AiraAiful/Members.vue'

import JuzmatchMemberDashboard from '@/components/view/template/Juzmatch/MemberDashboard.vue'
import RootsBranchManagement from '@/components/view/template/Roots/BranchManagement.vue'
import RootsCompanyManagement from '@/components/view/template/Roots/CompanyManagement.vue'
import AiraSeminarManagement from '@/components/view/template/Aira/SeminarManagement.vue'
import AiraBookingList from '@/components/view/template/Aira/BookingList.vue'
import AiraAgentManagement from '@/components/view/template/Aira/AgentManagement/AgentManagement.vue'
import AiraBroadcast from '@/components/view/template/Aira/Broadcast/Broadcast.vue'
import AiraApprovalBroadcast from '@/components/view/template/Aira/Broadcast/ApprovalBroadcast.vue'
import AiraMemberManagement from '@/components/view/template/Aira/MemberManagement/MemberManagement.vue'

import PowerbuyFacebookPostManager from '@/components/view/template/powerbuy/FacebookPostManager/main.vue'
import PowerbuyFacebookShearPostManager from '@/components/view/template/powerbuy/FacebookShearPostManager/main.vue'
import PowerbuyInstagramPostManager from '@/components/view/template/powerbuy/InstagramManager/main.vue'
import PowerbuyLineBroadcast from '@/components/view/template/powerbuy/LineBroadcast/main.vue'
import PowerbuyManagement from '@/components/view/template/powerbuy/Management/main.vue'
import RunnerManager from '@/components/view/template/runkan/main.vue'
import SahapanReward from '@/components/view/template/sahapan/main.vue'
import SecapMaintenanceServiceBooking from '@/components/view/template/secap/MaintenanceServiceBooking.vue'
import SecapServiceCenterManagement from '@/components/view/template/secap/ServiceCenterManagement.vue'
import TDagentmanagement from '@/components/view/template/tdtawandang/agentmanagement/main.vue'
import TDmanagement from '@/components/view/template/tdtawandang/management/main.vue'
import TDNotificationSetting from '@/components/view/template/tdtawandang/notificationsetting/main.vue'
import Template from '@/components/view/template/template'
import Questionaire from '@/components/view/template/tero/main.vue'
import Ticket from '@/components/view/template/ticket/main.vue'
import RabbitReplyFBPost from '@/components/view/template/ticket/RabbitReplyFBPost/main.vue'
import ToaAgentmanagement from '@/components/view/template/toa/agentmanagement/main.vue'
import ToaManagement from '@/components/view/template/toa/management/main.vue'
import ToaCrmAgreeTermsAndConditions from '@/components/view/template/toacrm/TermsAndConditions/AgreeTermsAndConditions.vue'
import ToaCrmTermsAndConditions from '@/components/view/template/toacrm/TermsAndConditions/TermsAndConditions.vue'
import ToaCampaign from '@/components/view/template/toaecoupon/Campaign'
import ToaMember from '@/components/view/template/toaecoupon/Member'
import TrueidSystemMaintenance from '@/components/view/template/trueid/SystemMaintenance.vue'
import YasaleAcAdminMenu from '@/components/view/template/YasaleAc/AdminMenu.vue'
import Ticket2agentmanagement from '@/components/view/ticket2/agentmanagement/main.vue'
import Ticket2management from '@/components/view/ticket2/management/main.vue'
import Productandbranch from '@/components/view/ticket2/productandbranch/main.vue'
import Ticket2profile from '@/components/view/ticket2/profile/main.vue'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'
import Beacon from '@/components/view/Beacon/Controller.vue'
import CheckInCheckOut from '@/components/view/CheckInCheckOut'
import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'
import AdsSimulator from '@/components/view/AdsSimulator/AdsSimulator.vue'
import AssetWiseExecutiveManagement from '@/components/view/template/AssetWise/ExecutiveManagement'
import AssetWiseManagement from '@/components/view/template/AssetWise/Management'
import AssetWiseBrokerManagement from '@/components/view/template/AssetWise/Management/Broker'
import AssetWiseLandSaleManagement from '@/components/view/template/AssetWise/Management/LandSale'
import AssetWiseExecutiveRecordManagement from '@/components/view/template/AssetWise/Management/ExecutiveRecord'
import AssetWiseBroadcast from '@/components/view/template/AssetWise/Broadcast'
import AssetWiseExecutiveBroadcast from '@/components/view/template/AssetWise/ExecutiveBroadcast'
import AssetWiseExecutiveBroadcastCreate from '@/components/view/template/AssetWise/ExecutiveBroadcastCreate'
import TcpBroadcast from '@/components/view/template/tcp/Broadcast'

import Login from '@/components/login/Login.vue'
import LoginLowScope from '@/components/login/LoginLowScope.vue'
import Nigol from '@/components/login/Nigol.vue'
import Chat2PayLogin from '@/components/login/Chat2Pay.vue'
import LineNotify from '@/components/view/linenotify/Linenotify.vue'
import ConnectLine from '@/components/login/ConnectLine.vue'
import PrepareLine from '@/components/view/linenotify/Prepare.vue'

import PageConfig from '@/components/view/AdvancedSetting/PageConfig.vue'
import WarroomConfig from '@/components/view/AdvancedSetting/WarroomConfig.vue'
import WhatsappTemplateManagment from '@/components/view/whatsapp/TemplateManagement'

import Ticket3Checkin from '@/components/view/ticket3/checkin/index.vue'
import Ticket3TicketList from '@/components/view/ticket3/ticket-management/TicketList.vue'
import Ticket3FunnelView from '@/components/view/ticket3/ticket-management/FunnelView.vue'
import Ticket3AgentView from '@/components/view/ticket3/ticket-management/AgentView.vue'
import Ticket3Setting from '@/components/view/ticket3/ticket-management/Setting/index.vue'
import Ticket3AgentOverview from '@/components/view/ticket3/agent-management/overview/index.vue'
import Ticket3AgentPerformance from '@/components/view/ticket3/agent-management/AgentPerformance.vue'
import Ticket3AgentPerformanceSummary from '@/components/view/ticket3/agent-management/agents/Summary/index.vue'
import Ticket3AgentPerformanceDetail from '@/components/view/ticket3/agent-management/agents/Performance/index.vue'
import Ticket3AgentManage from '@/components/view/ticket3/agent-management/AgentManage.vue'
import Ticket3AgentWorkTime from '@/components/view/ticket3/agent-management/agents/WorkTime'
import Ticket3Wrapup from '@/components/view/ticket3/ticket-management/WrapUp/index.vue'
import LayoutTicketManagement from '@/components/view/ticket3/ticket-management/LayoutTicketManagement.vue'
import LayoutAgentManagement from '@/components/view/ticket3/agent-management/LayoutAgentManagement.vue'

import LayoutSurvey from '@/components/view/survey/LayoutSurvey.vue'
import Survey from '@/components/view/survey/survey/index.vue'

import TigerpolyMember from '@/components/view/template/tigerpoly/member/Member.vue'
import TigerpolyReporting from '@/components/view/template/tigerpoly/reporting/Reporting.vue'
import AllInOneChat from '@/components/view/AllInOneChat/AllInOneChat.vue'

import SuperrichBranch from '@/components/view/template/superrich/branch/Branch.vue'
import LonBroadcast from '@/components/view/LonBroadcast/LonBroadcast'

import FirstAnnouncement from '@/components/view/FirstAnnouncement'
import Audience from '@/components/view/stepmessage/index.vue'

import GptAnalyticsView from '@/components/view/chatgpt/GptAnalyticsView.vue'
import MyAllianzLinkManagement from '@/components/view/template/my-allianz/LinkManagement'
import LineRichMenu from '@/components/view/LineRichMenu'
import SurveyIframe from '@/components/view/SurveyIframe'
import EventTracking from '@/components/view/EventTracking'

import MetaCatalog from '@/components/callback/MetaCatalog.vue'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: LineNotify
      }
    ]
  },
  {
    path: '/connectline',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: ConnectLine
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: PrepareLine
      }
    ]
  },
  {
    path: '/callback',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: 'meta-catalog',
        name: 'MetaCatalog',
        component: MetaCatalog
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: Nigol
      },
      {
        path: 'login',
        name: 'login',
        component: Login
      },
      {
        path: 'login2',
        name: 'login-low-scope',
        component: LoginLowScope
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: Chat2PayLogin,
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'allinonechat-new',
        name: 'allinonechat-new',
        component: AllInOneChat,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat (New)'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'lon-broadcast',
        name: 'lon-broadcast',
        component: LonBroadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'LON Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'getcurrentlocation',
        name: 'getcurrentlocation',
        component: GetCurrentLocation
      },
      {
        path: 'ticket',
        name: 'ticket',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: SettingComponent,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'setting',
        name: 'setting-component',
        component: SettingComponent,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'productandbranch',
        name: 'productandbranch',
        component: Productandbranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Product and branch'
        }
      },
      {
        path: 'ticket2profile',
        name: 'ticket2profile',
        component: Ticket2profile,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'ticket2management',
        name: 'ticket2management',
        component: Ticket2management,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'ticket2agentmanagement',
        name: 'ticket2agentmanagement',
        component: Ticket2agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'tdmanagement',
        name: 'tdmanagement',
        component: TDmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'tdagentmanagement',
        name: 'tdagentmanagement',
        component: TDagentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'tdnotificationsetting',
        name: 'tdnotificationsetting',
        component: TDNotificationSetting,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat setting'
        }
      },
      {
        path: 'yasale-ac-admin-menu',
        name: 'YasaleAcAdminMenu',
        component: YasaleAcAdminMenu,
        beforeEnter: guardRoute,
        meta: {
          title: 'Admin Menu'
        }
      },
      {
        path: 'nongtungjai',
        component: {
          name: 'nongtungjai',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'patient-history',
            name: 'patient-history',
            component: NongtungjaiPatientHistory,
            beforeEnter: guardRoute,
            meta: {
              title: 'Patient History'
            }
          },
          {
            path: 'patient-history/:id',
            name: 'patient-history-details',
            component: NongtungjaiPatientHistoryDetails,
            beforeEnter: guardRoute,
            meta: {
              title: 'Patient History Details'
            }
          },
          {
            path: 'self-referral',
            name: 'self-referral',
            component: NongtungjaiSelfReferral,
            beforeEnter: guardRoute,
            meta: {
              title: 'ข้อมูลการบำบัด'
            }
          }
        ]
      },
      {
        path: 'tremendous',
        component: {
          name: 'tremendous',

          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'customer',
            name: 'customer',
            component: TremendousCustomerList,
            beforeEnter: guardRoute,
            meta: {
              title: 'Customer List'
            }
          },
          {
            path: 'customer/:id',
            name: 'customer-info',
            component: TremendousCustomerInfo,
            beforeEnter: guardRoute,
            meta: {
              title: 'Customer Information'
            }
          }
        ]
      },
      {
        path: 'juzmatch',
        component: {
          name: 'juzmatch',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'member-dashboard',
            name: 'member-dashboard',
            component: JuzmatchMemberDashboard,
            beforeEnter: guardRoute,
            meta: {
              title: 'Member Dashboard'
            }
          }
        ]
      },
      {
        path: 'aira-aiful',
        component: {
          name: 'aira-aiful',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'members',
            name: 'members',
            component: AiraAifuMember,
            beforeEnter: guardRoute,
            meta: {
              title: 'Member'
            }
          }
        ]
      },
      {
        path: 'roots',
        component: {
          name: 'roots',
          template: '<router-view></router-view>'
        },

        beforeEnter: guardRoute,
        children: [
          {
            path: 'company-management',
            name: 'company-management',
            component: RootsCompanyManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Company Management'
            }
          },
          {
            path: 'company-management/:id',
            name: 'company-branch-management',
            component: RootsBranchManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Branch Management'
            }
          }
        ]
      },
      {
        path: 'aira',
        component: {
          name: 'roots',
          template: '<router-view></router-view>'
        },

        beforeEnter: guardRoute,
        children: [
          {
            path: 'seminar-management',
            name: 'seminar-management',
            component: AiraSeminarManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Seminar Management'
            }
          },
          {
            path: 'booking-list',
            name: 'booking-list',
            component: AiraBookingList,
            beforeEnter: guardRoute,
            meta: {
              title: 'Booking List'
            }
          },
          {
            path: 'agent-management',
            name: 'agent-management',
            component: AiraAgentManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Agent Management'
            }
          },
          {
            path: 'broadcast',
            name: 'aira-broadcast',
            component: AiraBroadcast,
            beforeEnter: guardRoute,
            meta: {
              title: 'Broadcast'
            }
          },
          {
            path: 'approval-broadcast',
            name: 'approval-broadcast',
            component: AiraApprovalBroadcast,
            beforeEnter: guardRoute,
            meta: {
              title: 'Approval Broadcast'
            }
          },
          {
            path: 'member-management',
            component: AiraMemberManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Member Management'
            }
          }
        ]
      },

      {
        path: 'toaagentmanagement',
        name: 'toaagentmanagement',
        component: ToaAgentmanagement
      },
      {
        path: 'toamanagement',
        name: 'toamanagement',
        component: ToaManagement
      },
      {
        path: 'cityfreshmanagement',
        name: 'cityfreshmanagement',
        component: CityFreshManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'cityfreshagentmanagement',
        name: 'cityfreshagentmanagement',
        component: CityFreshAgentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'cityfreshprofile',
        name: 'cityfreshprofile',
        component: CityFreshProfile,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'rabbitreplyfbpost',
        name: 'rabbitreplyfbpost',
        component: RabbitReplyFBPost,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply Facebook Post'
        }
      },
      {
        path: 'secap-service-center-management',
        name: 'SecapServiceCenterManagement',
        component: SecapServiceCenterManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Service Center Management'
        }
      },
      {
        path: 'secap-maintenance-service-booking',
        name: 'SecapMaintenanceServiceBooking',
        component: SecapMaintenanceServiceBooking,
        beforeEnter: guardRoute,
        meta: {
          title: 'Maintenance Service Booking'
        }
      },
      {
        path: 'hopinnhr-human-resource',
        name: 'HopinnHrHumanResource',
        component: HopinnHrHumanResource,
        beforeEnter: guardRoute,
        meta: {
          title: 'Human Resource'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        path: 'RedeemCode',
        name: 'RedeemCode',
        component: RedeemCode,
        beforeEnter: guardRoute,
        meta: {
          title: 'Redeem Code'
        }
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live'
        }
      },
      {
        path: 'RewardManager',
        name: 'RewardManager',
        component: SahapanReward,
        beforeEnter: guardRoute,
        meta: {
          title: 'Sahapan Reward'
        }
      },
      {
        path: 'Questionaire',
        name: 'Questionaire',
        component: Questionaire,
        beforeEnter: guardRoute,
        meta: {
          title: 'Questionaire'
        }
      },
      {
        path: 'agentmanagement',
        name: 'AgentManagement',
        component: Agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'PowerbuyManagement',
        name: 'PowerbuyManagement',
        component: PowerbuyManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Management'
        }
      },
      {
        path: 'PowerbuyAnalytics',
        name: 'PowerbuyAnalytics',
        component: PowerbuyAnalytics,
        beforeEnter: guardRoute,
        meta: {
          title: 'Analytics'
        }
      },
      {
        path: 'PowerbuyLineBroadcast',
        name: 'PowerbuyLineBroadcast',
        component: PowerbuyLineBroadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Line Broadcast'
        }
      },
      {
        path: 'PowerbuyFacebookPostManager',
        name: 'PowerbuyFacebookPostManager',
        component: PowerbuyFacebookPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'PowerbuyInstagramPostManager',
        name: 'PowerbuyInstagramPostManager',
        component: PowerbuyInstagramPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'PowerbuyFacebookShearPostManager',
        name: 'PowerbuyFacebookShearPostManager',
        component: PowerbuyFacebookShearPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'powerbuy',
        component: {
          name: 'powerbuy',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'branch-management',
            name: 'branch-management',
            component: PowerbuyBranchManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Branch Management'
            }
          },
          {
            path: 'branch-management/view/:id',
            name: 'sub-branch-management',
            component: PowerbuySubBranchManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Sub Branch Management'
            }
          }
        ]
      },
      {
        path: 'bbq',
        component: {
          name: 'bbq',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'unanswered-message-info',
            name: 'unanswered-message-info',
            component: BbqUnansweredMsgInfo,
            beforeEnter: guardRoute,
            meta: {
              title: 'Unanswered Message Info'
            }
          }
        ]
      },
      {
        path: 'toacrm',
        component: {
          name: 'toacrm',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'terms-and-conditions',
            name: 'terms-and-conditions',
            component: ToaCrmTermsAndConditions,
            beforeEnter: guardRoute,
            meta: {
              title: 'Terms & Conditions'
            }
          },
          {
            path: 'agree-terms-and-conditions',
            name: 'agree-terms-and-conditions',
            component: ToaCrmAgreeTermsAndConditions,
            beforeEnter: guardRoute,
            meta: {
              title: 'Agree Terms & Conditions'
            }
          }
        ]
      },
      {
        path: 'runnerrunkan',
        name: 'Runner Manager',
        component: RunnerManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Runner Manager'
        }
      },
      {
        path: 'KingkitchenMember',
        name: 'KingkitchenMember',
        component: KingkitchenMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Member'
        }
      },
      {
        path: 'KingkitchenAdminMenu',
        name: 'KingkitchenAdminmenu',
        component: KingkitchenAdminmenu,
        beforeEnter: guardRoute,
        meta: {
          title: 'Adminmenu'
        }
      },
      {
        path: 'FoodguruCustomer',
        name: 'FoodguruCustomer',
        component: FoodguruCustomer,
        beforeEnter: guardRoute,
        meta: {
          title: 'Customer'
        }
      },
      {
        path: 'LamyManagement',
        name: 'LamyManagement',
        component: LamyManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'News/Promotions, Gift'
        }
      },
      {
        path: 'Membership',
        name: 'Membership',
        component: LamyMembership,
        beforeEnter: guardRoute,
        meta: {
          title: 'Membership'
        }
      },
      {
        path: 'PurchaseBehavior',
        name: 'PurchaseBehavior',
        component: LamyPurchaseBehavior,
        beforeEnter: guardRoute,
        meta: {
          title: 'Purchase Behavior'
        }
      },
      {
        path: 'LamyProductAndBranch',
        name: 'LamyProductAndBranch',
        component: LamyProductAndBranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Product & Branch'
        }
      },
      {
        path: 'toamember',
        name: 'toamember',
        component: ToaMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Member'
        }
      },
      {
        path: 'toacampaign',
        name: 'toacampaign',
        component: ToaCampaign,
        beforeEnter: guardRoute,
        meta: {
          title: 'Campaign'
        }
      },
      {
        path: 'trueid',
        beforeEnter: guardRoute,
        component: {
          name: 'trueid',
          template: '<router-view />'
        },
        children: [
          {
            path: 'system-maintenance',
            name: 'system-maintenance',
            component: TrueidSystemMaintenance,
            beforeEnter: guardRoute,
            meta: {
              title: 'System maintenance'
            }
          },

          {
            path: '',
            redirect: 'system-maintenance'
          }
        ]
      },

      {
        path: 'partner',
        component: {
          name: 'partner',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'profile'
          },
          {
            path: 'profile',
            name: 'profile',
            component: PProfile,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Profile'
            }
          },
          {
            path: 'blog',
            name: 'blog',
            component: PBlog,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Blog'
            }
          },
          {
            path: 'redeemcode',
            name: 'redeemcode',
            component: PRedeemCode,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Redeem Code'
            }
          }
          // {
          //   path: 'customer',
          //   name: 'customer',
          //   component: PCustomer,
          //   beforeEnter: guardPartnerRoute,
          //   meta: {
          //     title: 'Partner Customer'
          //   }
          // }
        ]
      },
      {
        path: 'export',
        name: 'export',
        component: Export,
        beforeEnter: guardRoute,
        meta: {
          title: 'Export'
        }
      },
      {
        path: 'ads-simulator',
        name: 'adssimulator',
        component: AdsSimulator,
        beforeEnter: guardRoute,
        meta: {
          title: 'Messenger Ads Simulator'
        }
      },
      {
        path: 'beacon',
        name: 'beacon',
        component: Beacon,
        beforeEnter: guardRoute,
        meta: {
          title: 'Beacon'
        }
      },
      {
        path: 'advanced-setting',
        beforeEnter: guardRoute,
        component: {
          name: 'advanced-setting',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: 'page-config',
            name: 'page-config',
            component: PageConfig
          },
          {
            path: 'warroom-config',
            name: 'warroom-config',
            component: WarroomConfig
          }
        ]
      },
      {
        path: 'assetwise/executive-management',
        name: 'assetwise-executive-management',
        component: AssetWiseExecutiveManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Executive Management'
        }
      },
      {
        path: 'assetwise/management',
        name: 'assetwise-management',
        component: AssetWiseManagement,
        beforeEnter: guardRoute,
        redirect: {
          name: 'assetwise-management-land-sales'
        },
        children: [
          {
            path: 'brokers',
            name: 'assetwise-management-brokers',
            component: AssetWiseBrokerManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Brokers'
            }
          },
          {
            path: 'land-sales',
            name: 'assetwise-management-land-sales',
            component: AssetWiseLandSaleManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Land Sales'
            }
          },
          {
            path: 'executive-records',
            name: 'assetwise-management-executive-records',
            component: AssetWiseExecutiveRecordManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Executive Records'
            }
          }
        ]
      },
      {
        path: 'assetwise/broadcast',
        name: 'assetwise-broadcast',
        component: AssetWiseBroadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        },
        redirect: {
          name: 'assetwise-broadcast-main'
        },
        children: [
          {
            path: 'main',
            name: 'assetwise-broadcast-main',
            component: Broadcast,
            beforeEnter: guardRoute,
            props: {
              child: true
            }
          },
          {
            path: 'executive',
            name: 'assetwise-broadcast-executive',
            component: AssetWiseExecutiveBroadcast,
            beforeEnter: guardRoute
          },
          {
            path: 'executive/create',
            name: 'assetwise-broadcast-executive-create',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute
          },
          {
            path: 'executive/:id',
            name: 'assetwise-broadcast-executive-view',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute,
            props: {
              readonly: true
            }
          },
          {
            path: 'executive/:id/edit',
            name: 'assetwise-broadcast-executive-edit',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute,
            props: {
              edit: true
            }
          }
        ]
      },
      {
        path: 'whatsapp-template-management',
        name: 'WhatsappTemplateManagment',
        component: WhatsappTemplateManagment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Whatsapp Template Managment'
        }
      },
      {
        path: 'tcp',
        beforeEnter: guardRoute,
        component: {
          name: 'tcp',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: 'broadcast',
            name: 'tcp-broadcast',
            component: TcpBroadcast
          }
        ]
      },
      {
        path: 'ticket3',
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        },
        component: {
          name: 'ticket3',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'checkin'
          },
          {
            path: 'checkin',
            name: 'ticket3-checkin',
            component: Ticket3Checkin
          },
          {
            path: 'ticket-management',
            name: 'ticket3-management',
            component: LayoutTicketManagement,
            children: [
              {
                path: '',
                redirect: 'ticket'
              },
              {
                path: 'ticket',
                name: 'ticket3-ticket-list',
                component: Ticket3TicketList
              },
              {
                path: 'funnel',
                name: 'ticket3-funnel-view',
                component: Ticket3FunnelView
              },
              {
                path: 'agent',
                name: 'ticket3-agent-view',
                component: Ticket3AgentView
              },
              { path: 'wrapup', name: 'ticket3-wrapup', component: Ticket3Wrapup },
              {
                path: 'setting',
                name: 'ticket3-setting',
                component: Ticket3Setting
              }
            ]
          },
          {
            path: 'agent-management',
            name: 'ticket3-agent-management',
            component: LayoutAgentManagement,
            children: [
              {
                path: 'agent',
                name: 'ticket3-agent-overview',
                component: Ticket3AgentOverview
              },
              {
                path: 'performance',
                name: 'ticket3-agent-performance',
                component: Ticket3AgentPerformance,
                children: [
                  {
                    path: 'summary',
                    name: 'ticket3-agent-performance-summary',
                    component: Ticket3AgentPerformanceSummary
                  },
                  {
                    path: 'detail',
                    name: 'ticket3-agent-performance-detail',
                    component: Ticket3AgentPerformanceDetail
                  },
                  {
                    path: 'work-time',
                    name: 'ticket3-agent-work-time',
                    component: Ticket3AgentWorkTime
                  },
                  {
                    path: '',
                    redirect: 'detail'
                  }
                ]
              },
              {
                path: 'manage',
                name: 'ticket3-admin-management',
                component: Ticket3AgentManage
              }
            ]
          }
        ]
      },
      {
        path: 'survey',
        name: 'survey',
        component: LayoutSurvey,
        children: [
          {
            path: '',
            component: Survey
          }
        ],
        beforeEnter: guardRoute
      },
      {
        path: 'tigerpoly/members',
        name: 'tigerpoly-members',
        component: TigerpolyMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Members'
        }
      },
      {
        path: 'tigerpoly/reporting',
        name: 'tigerpoly-reporting',
        component: TigerpolyReporting,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reporting'
        }
      },
      {
        path: 'check-in-check-out',
        name: 'check-in-check-out',
        component: CheckInCheckOut,
        beforeEnter: guardRoute,
        meta: {
          title: 'Check in - Check out'
        }
      },
      {
        path: 'superrich/branches',
        name: 'superrich-branches',
        component: SuperrichBranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Branches Management'
        }
      },
      {
        path: 'first-announcement',
        name: 'first-announcement',
        component: FirstAnnouncement,
        beforeEnter: guardRoute,
        meta: {
          title: 'First Announcement'
        }
      },
      {
        path: 'chat-gpt-analytics',
        name: 'chat-gpt-analytics',
        component: GptAnalyticsView,
        beforeEnter: guardRoute,
        meta: {
          title: 'Chat GPT Analytics'
        }
      },
      {
        path: 'audience',
        name: 'audience',
        component: Audience,
        beforeEnter: guardRoute,
        meta: {
          title: 'Audience'
        }
      },
      {
        path: 'my-allianz/link-management',
        name: 'my-allianz-link-management',
        component: MyAllianzLinkManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Link Management'
        }
      },
      {
        path: 'line-rich-menu',
        name: 'line-rich-menu',
        component: LineRichMenu,
        beforeEnter: guardRoute,
        meta: {
          title: 'LINE Rich Menu'
        }
      },
      {
        path: 'survey-iframe',
        name: 'survey-iframe',
        component: SurveyIframe,
        beforeEnter: guardRoute,
        meta: {
          title: 'Survey'
        }
      },
      {
        path: 'event-tracking',
        name: 'event-tracking',
        component: EventTracking,
        beforeEnter: guardRoute,
        meta: {
          title: 'Event Tracking'
        }
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched
  //   .slice()
  //   .reverse()
  //   .find((r) => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (to.name == 'dashboard' && to.query && to.query.tab == 'ceemeagain') {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { tab: 'ceemeagain' }
      })
      return
    }
  }

  let query = { utm_source: to.query.utm_source }
  if (!query.redirect) {
    query.redirect = to.fullPath
  }

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function () {
            // checkTokenStatus(next)
            next()
          },
          function (error) {
            console.error(error)
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function () {
            // checkTokenStatus(next)
            next()
          },
          function (error) {
            console.error(error)
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardPartnerRoute(to, from, next) {
  let query = { utm_source: to.query.utm_source }
  if (!query.redirect) {
    query.redirect = to.fullPath
  }
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/nigol',
      query: query
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    }
  }
}

// function checkTokenStatus(next) {
//   var vm = router.app
//   if (
//     store.state.selectedBot &&
//     Object.keys(store.state.selectedBot).length &&
//     store.state.selectedBot.hasOwnProperty('statustoken') &&
//     !store.state.selectedBot.statustoken
//   ) {
//     // Swal({
//     //   icon: 'error',
//     //   width: 650,
//     //   allowOutsideClick: false,
//     //   confirmButtonColor: '#d33',
//     //   title: vm.$t('Hey! Your chatbot has connection error.'),
//     //   html: vm.$t('Admin page please log into the zwiz system') + ' <a href="https://cms.zwiz.ai/en/login">(https://cms.zwiz.ai/en/login)</a> ' + vm.$t('again.')
//     // }).then(() => {
//     //   if (store.getters.isFacebook) {
//     //     logout(next)
//     //   }
//     // })
//   }
// }

// function logout(next) {
//   var isFacebook = store.getters.isFacebook
//   store.dispatch('logout', null).then()
//   if (isFacebook) {
//     next({
//       path: '/' + store.getters.currentLang + '/nigol'
//     })
//   } else {
//     next({
//       path: '/' + store.getters.currentLang + '/nigol'
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/router/index.js